module.exports = __webpack_public_path__ + "img/advanced-electronics-2.dbaae22a.png";